import { Component, HostBinding, inject, Input, signal } from '@angular/core';
import { ThemeService } from '../services/theme';
import { IframeModal } from '../iframe-modal/iframe-modal';

const SURVEY_STORAGE_KEY = 'ai_survey_completed';

@Component({
  selector: 'app-survey-banner',
  standalone: true,
  imports: [IframeModal],
  templateUrl: './survey-banner.html',
  styleUrl: './survey-banner.scss',
})
export class SurveyBanner {
  private readonly themeService = inject(ThemeService);
  readonly isDark = this.themeService.isDark;

  @Input() isSubpage = false;
  @HostBinding('class.subpage') get subpageClass() {
    return this.isSubpage && !this.themeService.isFinnet();
  }

  @HostBinding('style.display') get hostDisplay(): string {
    return this.isCompleted() && !this.justCompleted() ? 'none' : 'block';
  }

  readonly isCompleted = signal(localStorage.getItem(SURVEY_STORAGE_KEY) === '1');
  readonly justCompleted = signal(false);
  readonly isModalOpen = signal(false);
  readonly surveyUrl = 'https://www.surveymonkey.com/r/GQSF6JZ';

  onSurveyClick(): void {
    this.isModalOpen.set(true);
  }

  onSurveyComplete(): void {
    localStorage.setItem(SURVEY_STORAGE_KEY, '1');
    this.isCompleted.set(true);
    this.justCompleted.set(true);
  }
}
